import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
import { useExpandGroup } from './expand-group-context';
const useStyles = createUseStyles({
  root: {}
});

const ExpandItem = props => {
  const {
    classes: classesProp,
    className: classNameProp,
    children,
    initialExpandStatus = 'collapsed',
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  const {
    expandStatus,
    updateExpanded
  } = useExpandGroup(initialExpandStatus);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), children(expandStatus, updateExpanded));
};

export default ExpandItem;